import AbiTradePartnerApiUrls from '../../../apiUrls/AbiTradePartnerApiUrls'
import { FileForUserGetPartyId } from '../../../common/FileForUserCommon'

export const fetchPartyLookup = async (partyCode, formSections) => {
  try {
    // Build the URL based on whether partyCode is provided
    let url = AbiTradePartnerApiUrls.GET + `?partyId=${FileForUserGetPartyId()}`
    if (partyCode) {
      url += `&partyCode=${partyCode}`
    }

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
      }
    })

    if (!response.ok) {
      console.log('Error fetching party lookup')
      return []
    }

    const json = await response.json()

    // Check if data exists and is an array
    if (!json.data || !Array.isArray(json.data)) {
      console.log('No data returned from party lookup')
      return []
    }

    if (formSections === 'header') {
      if (partyCode === 'IM' || partyCode === 'CN' || partyCode === 'DN') {
        return json.data.map((u) => ({
          value: `${u.taxIdNumber} - ${u.id}`,
          description: `${u.taxIdNumber} - ${u.name}`
        }))
      } else if (partyCode === 'FF') {
        return json.data.map((u) => ({
          value: u.taxIdNumber ? `${u.taxIdNumber} - ${u.id}` : u.id,
          description: u.taxIdNumber ? `${u.taxIdNumber} - ${u.name}` : u.name
        }))
      } else {
        return json.data.map((u) => ({
          value: u.id,
          description: u.partyMasterName || u.name || 'Unknown'
        }))
      }
    } else if (formSections === 'lineItem') {
      // For line item parties - return all trade partners with full data
      return json.data.map((u) => ({
        value: u.id,
        description: u.partyMasterName || u.name || 'Unknown',
        // Include full data for auto-populating fields
        data: {
          partyCode: u.partyCode || '',
          name: u.name || '',
          identifier: u.partyIdentifier || u.taxIdNumber || '',
          duns: u.duns || '',
          address1: u.address1 || '',
          address2: u.address2 || '',
          city: u.city || '',
          stateProvince: u.stateProvince || '',
          postalCode: u.postalCode || '',
          country: u.countryCode || ''
        }
      }))
    } else {
      return json.data.map((u) => ({
        value: u.id,
        description: u.partyMasterName || u.name || 'Unknown'
      }))
    }
  } catch (error) {
    console.log('Error fetching party lookup', error)
    return []
  }
}
